import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'charInStr'
})
export class CharInStrPipe implements PipeTransform {

  transform(value: string, index: number): string {
    if (value) {
      return value.split('')[index] || '-';
    }
    return '-';
  }

}
